import { useFormikContext } from 'formik';
import { useEffect, useRef, useState } from 'react';
import {
  clearCustomSlide,
  handleImageChange,
  handleImageLoad,
} from './utils/slidePromptUtils';
import { useSettings } from '../useSettings';

export const useSlidePromptHandlers = (
  name,
  setPromptError,
  setShowPromptError,
  slideUrl,
  defaultSlideUrl,
) => {
  const {
    setPromptChanges,
    setSubmitEnabled,
    updatePromptsInfo,
    usePremiumPrompts,
  } = useSettings();
  const imgRef = useRef();
  const { values, setFieldValue } = useFormikContext();
  const isNew = values[name] !== undefined;
  const [currentSlideUrl, setCurrentSlideUrl] = useState(slideUrl);
  const isDefault =
    currentSlideUrl === defaultSlideUrl && values[name] === undefined;

  useEffect(() => {
    setCurrentSlideUrl(slideUrl);
  }, [slideUrl]);

  // title matrix
  // isNew  | currentSlideUrl | revert title
  // no     | default         | n/a (no need to revert)
  // no     | !default        | Revert to default
  // yes    | default         | Revert to default
  // yes    | !default        | Revert to previous

  const revertTitle = `Revert to ${
    isNew && currentSlideUrl !== defaultSlideUrl ? 'previous' : 'default'
  } slide`;

  const clearInputValue = () => {
    imgRef.current.value = [];
  };

  const onRevertClick = () =>
    clearCustomSlide(
      name,
      isNew,
      imgRef,
      slideUrl,
      defaultSlideUrl,
      currentSlideUrl,
      setPromptChanges,
      clearInputValue,
      setFieldValue,
      setCurrentSlideUrl,
    );

  const onImageLoad = () =>
    handleImageLoad(imgRef, setPromptError, setShowPromptError, onRevertClick);

  const onImgChange = (event) =>
    handleImageChange(
      event,
      name,
      defaultSlideUrl,
      setPromptChanges,
      setSubmitEnabled,
      setFieldValue,
    );

  return {
    imgRef,
    isDefault,
    revertTitle,
    values,
    currentSlideUrl,
    updatePromptsInfo,
    usePremiumPrompts,
    onImageLoad,
    onImgChange,
    onRevertClick,
  };
};
